/**
 * Defers work until after Largest Contentful Paint (then requestIdleCallback).
 * Used by cart promo scripts to avoid /cart.js during initial paint.
 */
(function runAfterLcpBootstrap() {
  /** @type {Array<() => void>} */
  const queue = [];
  let lcpComplete = false;
  let observerStarted = false;

  function idleRun(fn) {
    const idle =
      typeof window.requestIdleCallback === 'function'
        ? window.requestIdleCallback
        : function (cb) {
            setTimeout(cb, 1);
          };
    idle(function () {
      try {
        fn();
      } catch (err) {
        console.error(err);
      }
    }, { timeout: 2000 });
  }

  function flushQueue() {
    if (lcpComplete) return;
    lcpComplete = true;
    const pending = queue.splice(0, queue.length);
    if (!pending.length) return;
    idleRun(function () {
      pending.forEach(function (cb) {
        try {
          cb();
        } catch (err) {
          console.error(err);
        }
      });
    });
  }

  /** @type {Window & { runAfterLcp?: (callback: () => void) => void }} */
  const win = window;

  win.runAfterLcp = function runAfterLcp(callback) {
    if (typeof callback !== 'function') return;
    if (lcpComplete) {
      idleRun(callback);
      return;
    }
    queue.push(callback);
    startObserver();
  };

  function whenDomReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      setTimeout(fn, 0);
    }
  }

  function startObserver() {
    if (observerStarted) return;
    observerStarted = true;

    if (typeof PerformanceObserver === 'undefined') {
      whenDomReady(flushQueue);
      return;
    }

    let flushed = false;
    function flushOnce() {
      if (flushed) return;
      flushed = true;
      flushQueue();
    }

    /** @type {PerformanceObserver | null} */
    let po = null;
    try {
      po = new PerformanceObserver(function (list) {
        if (list.getEntries().length) {
          po?.disconnect();
          flushOnce();
        }
      });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch {
      whenDomReady(flushOnce);
      return;
    }

    setTimeout(function () {
      po?.disconnect();
      flushOnce();
    }, 4000);
  }

  startObserver();
})();
